/**
 * Skrbniska stran modula Projekti (docs/ARHITEKTURA.md, 15): sifrant
 * projektov, register osnovnih sredstev, temeljnica meseca in zakljucek
 * meseca. Locena od nalaganja glavne knjige, da se nastavitve modula ne
 * mesajo z uvozom (odlocitev lastnika, 28. 10. 2026).
 */
import { MODUL_PROJEKTI } from '@koda/shared';
import { useEffect, useState, type JSX } from 'react';
import { Link, useParams } from 'react-router-dom';

import { api } from '../lib/api';
import { Projekti } from '../sestavni/Projekti';
import { RegisterOs } from '../sestavni/RegisterOs';
import { TemeljnicaMeseca } from '../sestavni/TemeljnicaMeseca';
import { ZakljucekMeseca } from '../sestavni/ZakljucekMeseca';

export function NastavitveProjektov(): JSX.Element {
  const { id = '' } = useParams();
  const [nazivPodjetja, setNazivPodjetja] = useState('');
  // null: modulov se nismo prebrali; stran ne sme najprej pokazati »ni vklopljen«.
  const [moduli, setModuli] = useState<string[] | null>(null);

  useEffect(() => {
    api
      .podjetja()
      .then((vsa) => {
        setNazivPodjetja(vsa.find((p) => p.id === id)?.naziv ?? '');
      })
      .catch(() => {
        /* naziv ni nujen za delovanje strani */
      });
    api
      .moduli(id)
      .then(setModuli)
      .catch(() => {
        setModuli([]);
      });
  }, [id]);

  const vklopljen = moduli?.includes(MODUL_PROJEKTI) ?? false;

  return (
    <main>
      <nav className="drobtine">
        <Link to="/">Podjetja</Link>
        <Link to={`/podjetje/${id}`}>{nazivPodjetja || 'Podjetje'}</Link>
      </nav>
      <h1>Nastavitve projektov</h1>
      <p className="podnaslov">
        Šifrant projektov, register osnovnih sredstev, temeljnica delitve amortizacije in zaključek
        meseca. Glavna knjiga se nalaga na strani{' '}
        <Link to={`/podjetje/${id}/uvoz`}>Nalaganje glavne knjige</Link>; odstotke po sredstvih
        ureja <Link to={`/podjetje/${id}/projekti/odstotki`}>Nastavitev odstotkov</Link>.
      </p>
      {moduli !== null && !vklopljen && (
        <p className="opozorilo">Modul Projekti pri tem podjetju ni vklopljen.</p>
      )}
      {vklopljen && (
        <>
          <Projekti podjetje={id} />
          <RegisterOs podjetje={id} />
          <TemeljnicaMeseca podjetje={id} />
          <ZakljucekMeseca podjetje={id} />
        </>
      )}
    </main>
  );
}
